import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const LabelsContext = createContext({});

const DEFAULTS = {
  profesionales: 'Profesionales',
};

export const LabelsProvider = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [labels, setLabels] = useState(DEFAULTS);

  const fetchLabels = useCallback(async () => {
    try {
      const { data } = await api.get('/configuracion/labels');
      setLabels({ ...DEFAULTS, ...data });
    } catch {}
  }, []);

  useEffect(() => {
    if (!authLoading && user) fetchLabels();
  }, [authLoading, user, fetchLabels]);

  const updateLabel = async (key, value) => {
    const trimmed = value.trim();
    const nuevo = { ...labels, [key]: trimmed || DEFAULTS[key] };
    setLabels(nuevo);
    try {
      await api.put('/configuracion/labels', { [key]: trimmed || DEFAULTS[key] });
    } catch {}
  };

  const getLabel = (key) => labels[key] || DEFAULTS[key] || key;

  return (
    <LabelsContext.Provider value={{ labels, getLabel, updateLabel }}>
      {children}
    </LabelsContext.Provider>
  );
};

export const useLabels = () => useContext(LabelsContext);
